import List from "./ProjectsList";
import Wrapper from "./Wrapper";

export default {
  List,
  Wrapper
};
